<template>
  <div id="card-intro">
    <div
      id="slide-text"
      class="text-center mx-4"
      v-html="t('ORIGINATION_CARD_INTRO')"
    ></div>
    <img
      alt="card-intro"
      class="position-absolute top-0 w-100 h-100"
      :src="`${useAsset('img/credit-line/card-intro.png')}`"
    />
    <button
      class="dismiss-alert-button"
      data-cy="alert-dismiss-button"
      @click="dismissCardIntro"
    >
      <i class="fa fa-times"></i>
    </button>
    <div class="position-absolute mt-5 mx-auto end-0 bottom-0">
      <button
        id="application-btn"
        class="btn-success btn rounded-pill fw-bold px-2 py-3 text-center"
        style="z-index: 100000"
        @click="goToCardShipment"
      >
        {{ t("CL_ONBOARDING_CARD_REQUEST") }}
      </button>
      <button
        id="application-withdraw"
        class="btn-success btn rounded-pill fw-bold px-2 py-3 text-center"
        style="z-index: 100000"
        @click="goWithdraw"
      >
        {{ t("CL_ONBOARDING_CARD_LATER") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import { useRouter } from "vue-router";

declare const Android: AndroidInterface;

export default defineComponent({
  name: "RegistrationCardIntro",
  methods: { useAsset },
  setup() {
    const { t } = useI18n();
    const router = useRouter();

    const dismissCardIntro = () => {
      logAnalyticsEvent(
        AnalyticEvents.CreditLine.DismissCardIntro,
        "Happy Path",
        "Dismiss card intro"
      );
      Android.creditOfferAccepted();
    };

    const goToCardShipment = () => {
      logAnalyticsEvent(
        AnalyticEvents.CreditLine.GoCardShipment,
        "Happy Path",
        "Go to card shipment after origination"
      );
      router.replace({ name: "CreditCardShippingAddressView" });
    };

    const goWithdraw = () => {
      logAnalyticsEvent(
        AnalyticEvents.CreditLine.GoWithdraw,
        "Happy Path",
        "Go to withdraw after origination"
      );
      router.replace({ name: "CreditLineWithdrawView" });
    };

    return { t, dismissCardIntro, goToCardShipment, goWithdraw };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
main {
  position: relative;
  & * {
    position: relative;
  }
}
#card-intro {
  height: 100%;
  width: 100vw;
  left: 0;
  top: 0;
  overflow: hidden;
  position: fixed;
}
#modal-title-header h5 {
  font-style: normal;
  font-family: Nunito;
  font-size: large;
}
.dismiss-alert-button {
  background: none;
  border: none;
  padding: 0;
  color: white;
  scale: 2;
  position: absolute;
  top: 2%;
  right: 1%;
}
#application-btn {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  border: none;
  bottom: 11%;
  text-align: center;
  width: 90%;
  color: #2f7243;
  border-radius: 10px !important;
  background: white;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.32);
}
#application-withdraw {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  border: none;
  bottom: 3%;
  text-align: center;
  width: 90%;
  color: white;
  border-radius: 10px !important;
  background: none;
}
#slide-text {
  font-size: 1.429rem;
  margin-top: 15%;
  z-index: 100;
}
#modal-btn-cta {
  border-radius: 10px;
  border: 1px solid var(--main-primary-500, #2c7040);
  background: var(--main-white, #fff);
  color: var(--main-primary-500, #2c7040);
  height: 44px;
  padding: 10px 24px;
  text-align: center;
  font-size: medium;
}
#exp-time {
  color: orange;
}
#pgraf-terms {
  color: #19191b;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Nunito;
  font-size: 15px;
  font-style: normal;
}
.cta-t-c {
  font-feature-settings: "clig" off, "liga" off;
  border: none;
  background-color: transparent;
  font-weight: bolder;
  font-family: Nunito;
  font-size: 15px;
  font-style: normal;
  color: #2c7040;
}
.offer-bg {
  background-color: #f6fbf9 !important;
  height: 90vh;
}
.light-text {
  color: $pj_color-cool-gray;
}
.accept-offer-btn {
  background: $pj-color-green;
  border-radius: 11px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.8px;
  color: $pj-color-white;
  width: 90%;
  height: 40px;
  border: none;
}
.accept-offer-btn-disabled {
  background-color: $pj-color-gray;
  cursor: not-allowed;
  border-radius: 11px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.8px;
  color: $pj-color-white;
  width: 90%;
  height: 40px;
  border: none;
}
#modal-body-terms {
  max-height: 65vh !important;
}
#modal-body-contract {
  max-height: 65vh !important;
}
.check-dot {
  width: 25px;
  height: 25px;
  background: rgba(255, 242, 242, 0.49);
  border: 1px solid $pj-color-black;
  box-sizing: border-box;
  margin-left: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.24px;
}
.check-legend {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.24px;
}
.payments-card {
  padding: 2.5%;
  border-radius: 10px;
  border-color: $pj-color-light-gray;
  border-width: thin;
  border-style: solid;
}
.reject-link {
  font-weight: 600;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.24px;
  color: $pj-color-green !important;
  text-decoration: none;
}
.reject-instore-link {
  font-weight: 600;
  font-size: 1rem;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.24px;
  color: $pj-color-green !important;
  text-decoration: none;
}
.option-btn {
  width: 100%;
  height: 50px;
  background-color: $pj-color-white;
  border-radius: 5px;
  color: $pj-color-green;
  text-align: left;
  font-size: 5vw;
  padding-left: 2.5%;
  border-color: $pj-color-green;
  border-width: thin;
}
.active-option {
  width: 100%;
  height: 50px;
  border: none;
  background-color: $pj-color-yellow-green;
  border-radius: 5px;
  color: $pj-color-white;
  text-align: left;
  font-size: 5vw;
  padding-left: 2.5%;
}
.signature-pad {
  border-radius: 25px;
  border-color: $pj-color-light-gray;
  border-width: thin;
  border-style: solid;
}
.sign-btn {
  background: $pj-color-green;
  border-radius: 11px;
  font-style: normal;
  font-weight: 600;
  margin-left: auto;
  margin-right: auto;
  bottom: 2%;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.8px;
  color: $pj-color-white;
  height: 40px;
  border: none;
}
.disabled {
  background-color: $pj-color-gray;
}
.offer-summary {
  display: flex;
  flex-direction: column;
  background: $pj-color-green-hover;
  padding: 10px;
  border-radius: 16px;
}
#other-offer-card {
  padding: 5%;
  background-color: $pj-color-green-hover;
  border-radius: 5%;
}
.loading-bg {
  background: #fff;
}
.gray-text {
  color: $pj-color-gray;
  font-weight: lighter;
}
.btn-disabled {
  background-color: $pj-color-gray;
  cursor: not-allowed;
}
.c1c {
  scale: 0.87 1 !important;
}
.sticky-container {
  position: sticky;
  bottom: 0;
  padding-bottom: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  border-top: $pj-color-green 2px solid;
  background-color: $pj-color-white;
}
.cancel-btn {
  color: $pj-color-green;
  background-color: white;
  border-color: transparent;
}
.clear-btn {
  color: $pj-color-yellow-green;
}
#preference-checkbox {
  height: 1rem;
  width: 1rem;
}
label {
  cursor: pointer;
  color: $pj-color-green;
  font-weight: bold;
  font-size: medium;
}
.checkbox {
  box-shadow: none;
  outline: none;
  border-color: $pj-color-green;
  &:checked {
    background-color: $pj-color-green;
    color: $pj-color-green;
    outline: none;
    border: 0;
    box-shadow: none;
  }
}
#credit-explainer {
  background-color: $pj-color-nav-bar-gray;
  width: 100%;
  position: relative;
  padding-top: 1.13rem;
  padding-bottom: 0.81rem;
  & h5 {
    & span {
      color: $pj-color-green;
      font-family: Inter;
      font-size: 2.25rem;
      font-style: normal;
      font-weight: 600;
      line-height: 2.5rem;
      letter-spacing: 0.01125rem;
    }
  }
  & .container {
    & .row {
      margin-top: 0.5rem;
    }
  }
}
#credit-explainer::before,
#credit-explainer::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 10%;
  background-color: $pj-color-nav-bar-gray;
}
#credit-explainer::before {
  left: -2rem;
}
#credit-explainer::after {
  right: -2rem;
}
#offer-explainer-footer {
  border-radius: 0 0 1rem 1rem;
  background: #f8fbf5;
  position: absolute;
  left: 0;
  right: 0;
  width: 90%;
  & .container {
    & .row {
      margin-top: 0.5rem;
      color: #666;
      font-family: Inter;
      font-size: 0.9375rem;
      font-style: normal;
      font-weight: 500;
      line-height: 1.4375rem;
      letter-spacing: 0.01875rem;
    }
  }
}
#offer-explainer-footer > div:nth-child(n) {
  margin-top: 0.5rem;
  color: #666;
}
#accept-step {
  padding-bottom: 25%;
}

img {
  z-index: -1;
}
</style>
